export const documentationCandidates = row => Array.isArray(row?.documentation_details?.candidates) ? row.documentation_details.candidates : []
export const documentTasks = candidate => Array.isArray(candidate?.document_collection_tasks)
  ? candidate.document_collection_tasks.filter(task => task && typeof task === "object") : []
export const checklistNames = task => {
  const items = task.checklist ?? task.checklistItems ?? task.checkList
  return Array.isArray(items) ? items.map(item => typeof item === "string" ? item : item?.itemName ?? item?.name ?? item?.checklistName).filter(value => value != null && value !== "") : []
}
export const taskFields = ["taskName", "taskStatus", "dueDate", "isSkip", "isReminded"]
